import { useEffect } from 'react'
import { BrowseViewDescriptor, useBrowseHistory } from '../context/browse-history-context'

// Records a detail-page view for the signed-in user. All the real logic
// (auth gating, per-session throttling, optimistic update, the API call)
// lives in BrowseHistoryProvider so every surface sees the new view at once.
export const useRecordBrowseView = (
  isAuthenticated: boolean,
  descriptor: BrowseViewDescriptor | null
) => {
  const { recordView } = useBrowseHistory()
  const tmdbId = descriptor?.tmdbId
  const mediaType = descriptor?.mediaType

  useEffect(() => {
    if (!isAuthenticated || !descriptor || !tmdbId || !mediaType) return
    recordView(descriptor)
    // Re-fire only when the actual title changes, not on object identity churn.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, mediaType, tmdbId])
}
